import React from "react";
import clsx from "clsx";

import { checkSurfaceType, ESurfaceType } from "../../helper";
import useStyles from "./styles";

interface IProps {
  surfaceType: ESurfaceType;
}

const SurfaceTableHeader = (props: IProps) => {
  const { surfaceType } = props;
  const classes = useStyles();
  const { isDirt, isTurfAndSynthetic } = checkSurfaceType(surfaceType);
  const dashedLineClassName = isDirt
    ? classes.dirtDashedBorder
    : classes.turfAndSyntheticDashedBorder;
  const compareValue = isDirt ? "1M" : "7.5F";

  const renderYearsDetails = (subHeader: string) => (
    <div className={clsx(classes.horseType, dashedLineClassName)}>
      <div className={classes.headCell}>{subHeader}</div>
      <div className={classes.yearsDetails}>
        <div
          className={clsx(
            classes.headCell,
            classes.narrowBorderTop,
            dashedLineClassName
          )}
        >
          Total
        </div>
        <div className={clsx(classes.headCell, classes.narrowBorderTop)}>2</div>
        <div className={clsx(classes.headCell, classes.narrowBorderTop)}>3</div>
        <div className={clsx(classes.headCell, classes.narrowBorderTop)}>
          4+
        </div>
      </div>
    </div>
  );

  return (
    <div className={classes.surfaceTableHeader}>
      <div
        className={clsx(classes.surfaceType, {
          [classes.dirt]: isDirt,
          [classes.turfAndSynthetic]: isTurfAndSynthetic
        })}
      >
        {surfaceType}
      </div>

      <div className={classes.horseTypes}>
        <div className={classes.unitedTotalCell}>
          <div />
          <div className={classes.total}>Total</div>
        </div>

        <div className={classes.horseTypesDetails}>
          <div className={clsx(classes.horseType, dashedLineClassName)}>
            <div className={classes.headCell}>Active &#60; 30 Days</div>
            <div className={classes.activeDetails}>
              <div
                className={clsx(
                  classes.headCell,
                  classes.narrowBorderTop,
                  dashedLineClassName
                )}
              >
                Total
              </div>
              <div className={clsx(classes.headCell, classes.narrowBorderTop)}>
                Utilization
              </div>
            </div>
          </div>
          {renderYearsDetails(`Sprinter < ${compareValue}`)}
          {renderYearsDetails(`Route > ${compareValue}`)}
        </div>
      </div>
    </div>
  );
};

export default SurfaceTableHeader;
